import http from '@/http/service'

import {Parceiro} from '@/soganhei'


function Perfil(){
    return http.get("/parceiro/perfil")

}

function SalvarPerfil(payload=Parceiro){
    return http.put("/parceiro/perfil",payload)

}

function Logo(payload){
    return http.post("/parceiro/perfil/logo",payload,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )

}

export default {
    Perfil, 
    SalvarPerfil, 
    Logo,
}